<template>
  <el-select
    v-model="bankAccountNo"
    placeholder="请输入账户名称或编号搜索"
    popper-class="select-account"
    style="width: 100%"
    :popper-append-to-body="false"
    filterable
    remote
    :remote-method="remoteMethod"
    @change="bankAccountNoChange"
  >
    <el-option
      v-for="(item, index) in searchBakAcctList"
      :key="index"
      :label="item.accountNumber"
      :value="item.bankAccountNo"
    >
      <div class="content">
        <div class="content-l">
          <div class="l-top">
            <div class="name" :class="[item.accountName.length >= 20 ? 'flex-style' : '']">{{item.accountName}}</div>
            <span v-if="item.bankAccountType !== 3">
              {{item.bankName}}
              <span class="tip-text" v-if="item.bankAccountType">({{item.bankAccountType === 1 ? '对私' : '对公'}})</span>
            </span>
          </div>
          <div class="acconut">{{item.accountNumber}}</div>
        </div>
      </div>
    </el-option>
  </el-select>
</template>

<script>
export default {
  props: {
    bakAcctList: {
      type: Array,
      default: () => ([]),
    },
    bankAccount: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      bankAccountNo: '',
      searchBakAcctList: [],
    };
  },
  watch: {
    bakAcctList: {
      deep: true,
      handler(list) {
        this.searchBakAcctList = [...list];
      },
      immediate: true,
    },
    bankAccount: {
      handler(val) {
        this.bankAccountNo = val || '';
      },
    },
  },
  methods: {
    bankAccountNoChange() {
      this.$emit('change', this.bankAccountNo);
    },
    remoteMethod(query) {
      if (query !== '') {
        const reg = new RegExp(query);
        this.searchBakAcctList = this.bakAcctList.filter((el) => {
          return reg.test(el.accountName) || reg.test(el.accountNumber);
        });
      } else {
        this.searchBakAcctList = this.bakAcctList;
      }
    },
  },
};
</script>


<style scoped lang="scss">
::v-deep {
  .select-account {
    .el-select-dropdown__item {
      height: auto;
    }
    .content {
      padding: 10px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      font-family: PingFangSC-Medium, PingFang SC;
      color: #4d4f51;
      .content-l {
        width: 100%;
        .l-top {
          display: flex;
          align-items: center;
        }
        .tip-text {
          margin-left: 0;
        }
        .name {
          font-weight: 500;
          line-height: 20px;
        }
        .flex-style {
          flex: 1;
        }
        span {
          color: #828487;
          font-weight: 400;
          font-size: 12px;
          margin-left: 12px;
          line-height: 18px;
        }
        .acconut {
          margin-top: 8px;
        }
      }
      .content-r {
        font-size: 10px;
        color: #c9ccd1;
        line-height: 14px;
      }
    }
  }
}
</style>
